import { useQuery } from '@tanstack/react-query';
import { ActiveIntegration } from '../auth/workspace';
import { useWorkspaces } from '../auth/WorkspaceState';

export const partners = [
  'box',
  'brightcove',
  'canvasstudio',
  'cloudflarestream',
  'dropbox',
  'googlechat',
  'googledrive',
  'googlecalendar',
  'googlemeet',
  'kaltura',
  'microsoftoutlook',
  'microsoftteams',
  'mux',
  'panopto',
  'rev',
  'slack',
  'vimeo',
  'webex',
  'wistia',
  'youtube',
  'zoom',
] as const;
export type IntegrationType = (typeof partners)[number];
export type PartnerType = IntegrationType | 'recap';

export type LinkedPlatform = ActiveIntegration;

/**
 * Hook to get all active integrations for the current workspace
 */
export function useWorkspaceIntegrations() {
  const { current: workspace } = useWorkspaces();

  return useQuery({
    queryKey: ['workspaceIntegrations', workspace?.workspaceId],
    queryFn: () => workspace?.activeIntegrations || [],
    enabled: !!workspace?.workspaceId,
  });
}

export function getPartnerLabel(partner: PartnerType): string {
  switch (partner) {
    case 'box':
      return 'Box';
    case 'brightcove':
      return 'Brightcove';
    case 'canvasstudio':
      return 'Canvas Studio';
    case 'cloudflarestream':
      return 'Cloudflare Stream';
    case 'dropbox':
      return 'Dropbox';
    case 'googlechat':
      return 'Google Chat';
    case 'googledrive':
      return 'Google Drive';
    case 'googlecalendar':
      return 'Google Calendar';
    case 'googlemeet':
      return 'Google Meet';
    case 'kaltura':
      return 'Kaltura';
    case 'microsoftoutlook':
      return 'Microsoft Outlook';
    case 'microsoftteams':
      return 'Microsoft Teams';
    case 'mux':
      return 'Mux';
    case 'panopto':
      return 'Panopto';
    case 'recap':
      return 'Recap';
    case 'rev':
      return 'Rev';
    case 'slack':
      return 'Slack';
    case 'vimeo':
      return 'Vimeo';
    case 'webex':
      return 'Webex';
    case 'wistia':
      return 'Wistia';
    case 'youtube':
      return 'YouTube';
    case 'zoom':
      return 'Zoom';
  }
}

export function getPartnerDownloadLink(partner: PartnerType): string {
  switch (partner) {
    case 'recap':
      return '';
    case 'youtube':
      return 'https://support.google.com/youtube/answer/56100';
    case 'brightcove':
      return 'https://studio.support.brightcove.com/media/manage/downloading-videos-video-cloud.html';
    case 'panopto':
      return 'https://support.panopto.com/s/article/How-to-Download-a-Session-as-an-MP4';
    case 'vimeo':
      return 'https://vimeo.com/blog/post/how-to-download-videos-from-vimeo/';
    default:
      return '';
  }
}
